<div class="user-icon-circle"
 [ngClass]="{'user-icon-circle-border': border, 'user-icon-circle-small': !large, 'user-icon-circle-large': large}"
>
  {{short ? short : firstLetter + '' + lastLetter}}
  <div class="user-icon-badge" [class]="badge" *ngIf="badge">
    <mat-icon>{{badge === 'signing' ? 'edit' : badge === 'denied' ? 'close' : 'done'}}</mat-icon>
  </div>
  <ng-content></ng-content>
</div>
